/**
 * Sloka sound line — Devanagari/Sanskrit + user-language transliteration only.
 * Never shows meaning/translation.
 */
import { useI18n } from "@/i18n/I18nContext";
import { resolveSlokaTransliteration } from "@/lib/chanting/sloka-transliteration";

export function SlokaSoundBlock({ slide, language, className = "" }) {
  const { lang } = useI18n();
  const resolved = resolveSlokaTransliteration(slide, language || lang);

  if (!resolved.sanskrit && !resolved.transliteration) return null;

  return (
    <div className={`space-y-1 text-left ${className}`} data-testid="sloka-sound-block">
      {resolved.sanskrit ? (
        <pre
          className="font-sanskrit text-primary text-lg leading-[1.6] whitespace-pre-line break-words"
          data-testid="sloka-sanskrit"
        >
          {resolved.sanskrit}
        </pre>
      ) : null}
      {resolved.transliteration ? (
        <>
          <p className="not-italic uppercase tracking-wide text-[10px] opacity-70" data-testid="sloka-transliteration-lang">
            {resolved.transliteration_language}
          </p>
          <pre
            className="text-sm italic text-muted-foreground leading-[1.6] whitespace-pre-line break-words"
            data-testid="sloka-transliteration"
          >
            {resolved.transliteration}
          </pre>
        </>
      ) : null}
    </div>
  );
}
